import React from "react";

import { ToggleButton } from "@/Components/v2/atoms/Button";
import { ToggleButtonGroup } from "@/Components/v2/molecule/ButtonGroup/";

import { useFlightingStore } from "../store/useFlightingStore";
import { ROIWindow } from "../types/common";

const ROI_OPTIONS: ROIWindow[] = [4, 12];

const ROIToggle: React.FC = () => {
  const ROIWindow = useFlightingStore((state) => state.chart.ROIWindow);
  const setROIWindow = useFlightingStore((state) => state.setROIWindow);

  const handleChange = (event: React.MouseEvent<HTMLElement>, newValue: string | null) => {
    if (newValue !== null) {
      const value = Number(newValue) as ROIWindow;
      setROIWindow(value);
    }
  };

  return (
    <ToggleButtonGroup value={ROIWindow.toString()} exclusive onChange={handleChange}>
      {ROI_OPTIONS.map((option) => (
        <ToggleButton key={option} value={option.toString()}>
          {option} Week ROI
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default ROIToggle;
